/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListQrOrderingDataRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {ListQrOrderingDataResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const listQrOrderingData = (request: ListQrOrderingDataRequest, options?: CashRequestOptions) => post<ListQrOrderingDataRequest, ListQrOrderingDataResponse>("/2.0/cash/list-qr-ordering-data", request, {...options, rejectOnError: true })